export const validate = (values: any) => {
  const errors: any = {};

  if (!values.venueId) {
    errors.venueId = "Required";
  }
  if (!values.roleRateId) {
    errors.roleRateId = "Required";
  }

  if (
    values.numberRequested &&
    values.selectedMembers &&
    values.numberRequested < values.selectedMembers?.length
  ) {
    errors.numberRequested =
      "Number of staff cannot be less than the selected staff";
  }

  if (!values.selectedMembers.length) {
    errors.selectedMembers = "Select at least one member";
  }

  if (values.scheduledEndTime.isBefore(values.scheduledStartTime)) {
    errors.scheduledEndTime = "End time cannot be before start time";
  }
  if (
    values.isDifferentCheckInTime &&
    values.checkOutTime.isBefore(values.checkInTime)
  ) {
    errors.checkOutTime = "End time cannot be before start time";
  }
  if (
    values.isSleepTime &&
    values.sleepEndTime.isBefore(values.sleepStartTime)
  ) {
    errors.sleepEndTime = "End time cannot be before start time";
  }
  if (
    values.isSleepTime &&
    values.actualSleepEndTime.isBefore(values.actualSleepStartTime)
  ) {
    errors.actualSleepEndTime = "End time cannot be before start time";
  }
  if (
    values.isDisturbedHours &&
    values.disturbedHoursEnd.isBefore(values.disturbedHoursStart)
  ) {
    errors.disturbedHoursEnd = "End time cannot be before start time";
  }

  return errors;
};
